import { render, staticRenderFns } from "./ReceiverOrderInfoRootPage.vue?vue&type=template&id=3a79b9bf&"
import script from "./ReceiverOrderInfoRootPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrderInfoRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports